<template>
  <div class="devices">
    
    <div class="p-2 rounded" name="header" style="height:682px;">
        <!-- Header -->
        <div class="row">
            <div class="col-md-6">
                <div v-show="mode=='default'">
                    <div class="input-group flex-nowrap mt-2">
                        <div class="btn fs-5 text-white" style="pointer-events: none; width: 40%;">
                            Devices
                        </div>
                        <input class="btn fw-light btn-dark fs-6 w-100 me-1 rounded" type="text" style="cursor: default;" placeholder="Filter by keyword" v-model="searchWord">
                        <button class="btn rounded fs-6 me-1" :class="{'btn-dark': searchType!='hostname', 'btn-kraken': searchType=='hostname'}" @click="setSearchType('hostname')">
                            <i class="fa-solid fa-desktop"></i>
                        </button>
                        <button class="btn rounded fs-6 me-1" :class="{'btn-dark': searchType!='alias', 'btn-kraken': searchType=='alias'}" @click="setSearchType('alias')">
                            <i class="fa-solid fa-id-badge"></i>
                        </button>
                        <button class="btn rounded fs-6" :class="{'btn-dark': searchType!='ip', 'btn-kraken': searchType=='ip'}" @click="setSearchType('ip')">
                            <i class="fa-solid fa-network-wired"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-1">
                <button v-show="mode=='default'" class="btn btn-kraken fs-6 w-100 mt-2" :disabled="gettingDevices || alteringDevice || deletingDevice" @click="getDevices(); devices=[];">
                    <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingDevices || alteringDevice || deletingDevice}"></i>
                </button>
                <button v-show="mode=='addition'" class="btn btn-kraken fs-6 w-100 mt-2" :disabled="gettingADevices || alteringDevice || deletingDevice" @click="getAvailableDevices">
                    <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingADevices || alteringDevice || deletingDevice}"></i>
                </button>
            </div>  
            <div class="col-md-1">
                <button v-show="mode=='default'" class="btn btn-kraken fs-6 w-100 mt-2" :disabled="gettingDevices || alteringDevice || deletingDevice" @click="setAddition(); getAvailableDevices();">
                    <i class="fa-solid fa-plus"></i>
                </button>
                <button v-show="mode=='edition'" class="btn btn-warning fs-6 w-100 mt-2" :disabled="alteringDevice" @click="clearEdition">
                    <i class="fa-solid fa-pen fa-beat"></i>
                </button>
                <button v-show="mode=='addition'" class="btn btn-danger fs-6 w-100 mt-2" @click="clearAddition">
                    <i class="fa-solid fa-close fa-beat-fade"></i>
                </button>
            </div>
        </div>
        
        <!-- Devices Main View -->
        <div v-show="mode=='default'" class="row">
          <div class="col-md-12">
            <div class="mt-3">
              <div class="tableFixHead mt-1" style="height: 570px;">
                  <table>
                      <thead>
                          <tr>
                              <th class="fw-light bg-black text-white fs-6 rounded" style="border-bottom: solid 1px rgb(110, 117, 124); width: 10px;" title="#">
                                  <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124); width: 100px;"  title="Hostname">
                                  <i class="fa-solid fa-lg fa-desktop"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124); width: 100px;"  title="Alias">
                                  <i class="fa-solid fa-lg fa-id-badge"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="IP Address">
                                  <i class="fa-solid fa-lg fa-network-wired"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="Turn On/Off Device">
                                  <i class="fa-solid fa-lg fa-cloud-arrow-down"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="Backup Status">
                                  <i class="fa-solid fa-lg fa-info"></i>
                              </th>
                              <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="Delete Device">
                                  <i class="fa-solid fa-lg fa-trash"></i>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(d, i) in filteredDevices" v-bind:key="i+1"> <!-- Content Row -->
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                  <p class="text-white fs-6 mt-1">{{i+1}}</p>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                  <p class="text-white fs-6 mt-1">{{d.hostname}}</p>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                  <p class="text-white fs-6 mt-1">{{d.alias}}</p>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 100px;">
                                  <p class="text-white fs-6 mt-1">{{d.ip}}</p>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                  <button class="btn fs-6" style="width: 60px;" :class="{'btn-dark': !d.do_backup, 'btn-kraken': d.do_backup}" @click="toggleStatus(d, i, 'do_backup')" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Turn On/Off ${d.hostname} backup execution.`">
                                    <i class="fa-solid fa-cloud-arrow-down"></i>
                                  </button>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                  <button class="btn fs-6" style="width: 60px;" :class="{'btn-danger': !d.backed_up, 'btn-success': d.backed_up}" :disabled="alteringDevice || deletingDevice || gettingDevices" title="Backup Status">
                                    <i class="fa-solid" :class="{'fa-close': !d.backed_up, 'fa-check': d.backed_up}"></i>
                                  </button>
                              </td>
                              <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                  <button class="btn fs-6 text-white" style="backgroundColor: rgb(135,0,0); width: 60px;" @click="deleteDevice(d, i)" :disabled="alteringDevice || deletingDevice || gettingDevices" :title="`Delete: ${d.hostname}`">
                                    <i class="fa-solid fa-trash"></i>
                                  </button>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Addition Section -->
        <div v-show="mode=='addition'"  class="p-1" :class="{'disabled-div': gettingDevices || alteringDevice || deletingDevice}" style="">
            <!-- Device selector. -->
            <div class="row mt-3">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <select class="btn btn-kraken fw-light fs-4 w-100" v-model="deviceToAdd" :disabled="gettingADevices">
                        <option value="device">Select a device to add...</option>
                        <option v-for="(d, i) in availableDevices" v-bind:key="i+1" :value="d" >{{d.hostname}}</option>
                    </select>
                </div>
                <div class="col-md-3"></div>
            </div>
            <!-- Set the initial parameters. -->
            <div :class="{'disabled-div': deviceToAdd == 'device'}">
                <div class="row mt-4" >
                    <div class="col-md-4"></div>
                    <!-- Toggle Monitoring -->
                    <div class="col-md-4 mt-1">
                        <div class="p-1">
                            <div class="bg-dark p-1 rounded">
                                <input type="text" class="btn bg-black text-white fs-3 fw-light w-100" value="Backup">
                                <div class="mt-1">
                                    <button class="btn w-100" style="height: 242px; font-size: 60px;" :class="{'btn-kraken': selected_device.do_backup, 'bg-black text-white': !selected_device.do_backup}" @click="selected_device.do_backup = !selected_device.do_backup">
                                        <i class="fa-solid fa-lg fa-cloud-arrow-down"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add the device. -->
                <div class="row" style="margin-top: 3%;">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <button class="btn btn-kraken w-100 fs-3" @click="addDevice">
                            <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': alteringDevice}"></i>
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </div>




  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"

import axios from "axios";

export default {
  name: 'Devices',
  components: {},
  data(){
    return {
      // General
        site: null,
        stage: null,
        mode: "default",
      // Devices
        availableDevices: [],
        gettingADevices: false,
        devices: [],
        devicesMessage: "Manage your devices backups.",
        gettingDevices: false,
        selected_device: {
            id_NE: null,
            do_backup: true
        },
        default_device: {
            id_NE: null,
            do_backup: true
        },
      // Add device to alchemy.
        deviceToAdd: "device",

      // Deleting device from alchemy.
        deletingDevice: false,

      // Edit device of alchemy 
        alteringDevice: false,
      // Filtering
        searchWord: "",
        searchType: "hostname"
    }
  },
  methods:{
    getAvailableDevices(){
        this.deviceToAdd = "device"
        this.devicesMessage = "Getting available devices..."
        this.gettingADevices = true
        this.availableDevices = []
        const params = {}
        const dest = this.site + '/autobackups/devices/getAvailableDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.availableDevices = rx.data.data.devices
                this.gettingADevices = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingADevices = false
                this.devicesMessage = "..."
        });
    },
    getDevices(){
        this.devicesMessage = "Getting devices..."
        this.gettingDevices = true
        //this.devices = []
        const params = {filter: 'all'}
        const dest = this.site + '/autobackups/devices/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.devices = rx.data.data.devices
                this.gettingDevices = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingDevices = false
                this.devicesMessage = "..."
        });
    },
    toggleStatus(_dev, _ind, _field){
        this.alteringDevice = true
        this.devicesMessage = "Modifying status of device, please wait..."
        //const params = {uid: _dev.uid, status: !Boolean(_dev[_field]), field: _field}
        const params = { id_NE: _dev.id_NE }
        const dest = this.site + '/autobackups/devices/toggleStatus'
        axios
            .post(dest, params)
            .then(rx => {
                // OK
                //this.devices[_ind][_field] = !Boolean(_dev[_field])
                this.getDevices()
                this.alteringDevice = false
                this.devicesMessage = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.alteringDevice = false
                this.devicesMessage = "..."
            });
    },

    // Addition
    addDevice(){
        // ID (id_NE) , do_backup
        this.alteringDevice = true
        this.selected_device.id_NE = this.deviceToAdd.id_NE
        const params = {}
        const dest = this.site + '/autobackups/devices/addDevice'
        axios
            .post(dest, this.selected_device)
            .then(rx => {
                // OK
                this.clearAddition()
                this.getAvailableDevices()
                this.getDevices()
                this.alteringDevice = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.alteringDevice = false
            });

    },
    setAddition(){
        this.mode = 'addition'
        this.devicesMessage = 'Addition mode.'
        //this.clearAddition()
    },
    clearAddition(){
        this.mode = 'default'
        this.devicesMessage = "..."
        this.selected_device = this.cloneObject(this.default_device)
    },

    // Edition
    clearEdition(){
        this.mode = 'default'
        this.devicesMessage = "..."
        this.selected_device = this.cloneObject(this.default_device)
    },

    // Delete
    deleteDevice(_dev, _ind){
        // Send only the UID.
        if (!confirm(`Delete device "${_dev.hostname}" ?`)){return}
        this.devicesMessage = "Deleting device, please wait..."
        this.deletingDevice = true
        const params = { id_NE: _dev.id_NE }
        const dest = this.site + '/autobackups/devices/deleteDevice'
        axios
            .post(dest, params)
            .then(rx => {
                // OK
                this.devices.splice(_ind, 1)
                this.devicesMessage = rx.data.message
                this.deletingDevice = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.deletingDevice = false
            });
    },

    // Filtering
    setSearchType(search_type){
      this.searchType = search_type
    },

    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getDevices()
    //this.getAvailableDevices()
  },
  computed: {
    filteredDevices(){
        if (this.searchWord == ''){
            return this.devices
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.devices.filter( device => String(device[this.searchType]).toLowerCase().includes( this.searchWord ) );
    }
  }
}
</script>

<style scoped>

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  /* Table with static header */
  .tableFixHead {
      overflow-y: auto;
      overflow-x: hidden;
    }
  .tableFixHead thead th {
      position: sticky;
      top: 0;
      text-align: center;
      z-index: 1;
  }
  table {
      border-collapse: collapse;
      width: 100%;
  }
  th, td {
      padding: 8px 16px;
  }
  th {
      background: #eee;
  }

  .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

    .temporal-disable{
        opacity: 0.5;
        pointer-events: none;
    }

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 211, 249);
    }

</style>
